import React from 'react';
import getConfig from "next/config";

import PostCategory from '../PostCategory/PostCategory';
import Divider from '../Divider/Divider';
import PostDate from '../PostDate/PostDate';
import FeaturedImage from '../FeaturedImage/FeaturedImage';
import ReadingTime from '../ReadingTime/ReadingTime';
import { IPost } from '../../lib/types';
import { GTM_CLASS, GTM_CLASS_PREFIX } from '../../lib/constant';
import classnames from 'classnames';

const { BASE_URL_MEDIA } = getConfig().publicRuntimeConfig;

import styles from './PostList.module.scss';

interface PostListProps {
  post: IPost;
}

const PostList = (props: PostListProps) => {
  const { post } = props;
  const categorySlug =
    post.categories &&
    post.categories.nodes &&
    post.categories.nodes.length > 0 &&
    post.categories.nodes[0].slug;
  return (
    <div className={styles['post-list']}>
      <div className={styles['post-list__featured-image']}>
        <FeaturedImage
          featuredImage={post.featuredImage}
          postTitle={post.title}
          height={281}
          width={450}
        />
      </div>
      <div className={styles['post-list__content']}>
        <a
          href={`${BASE_URL_MEDIA}${post.slug}/`}
          title={post.title}
          className={classnames(
            GTM_CLASS.REDIRECTION_IN_ARTICLE_LINK,
            `${GTM_CLASS_PREFIX}${categorySlug}`,
          )}
        >
          <h2>{post.title}</h2>
        </a>
        <div className={styles['post-list__meta']}>
          <PostCategory categories={post.categories} />
          <Divider />
          <ReadingTime time={post.readingTime} />
          <div className="d-none d-lg-inline-flex">
            <Divider />
          </div>
          <div className="d-none d-lg-inline-flex">
            <PostDate createdDate={post.date} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostList;
